export default __webpack_public_path__ + "static/media/2columns.a6527b83.svg";